import React from "react";

const ReservationTodayPage = () => {
  return <>ReservationTodayPage</>;
};

export default ReservationTodayPage;
